var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsDocumentAlertFillBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fill",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,15.2V84.8A1.21,1.21,0,0,0,22.16,86H78.25a1.2,1.2,0,0,0,1.2-1.2V34.4a1.22,1.22,0,0,0-.09-.46,1.16,1.16,0,0,0-.26-.39L59.83,14.35a1.2,1.2,0,0,0-.4-.26A1.18,1.18,0,0,0,59,14H22.16A1.21,1.21,0,0,0,21,15.2ZM58.2,20.07l15.16,15.1H58.2ZM47,43.29h7.49V61.6H47ZM50.7,67A3.7,3.7,0,1,1,47,70.7,3.72,3.72,0,0,1,50.7,67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsDocumentAlertFillBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_DocumentAlert_Fill_Black_RGB.ec72480c3b0b0244e4977749918d17a3.svg";
export { ForwardRef as ReactComponent };